var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"HorizontalScroll"},_vm._l((_vm.discussList),function(item,k){return _c('div',{key:k,class:['friend-get-item', _vm.isNeedTransition ? 'item-transition' : ''],style:(`left: -${_vm.discussItemTopDistance}rem;background:${_vm.background};color:${_vm.color}`)},[_vm._v(" "+_vm._s(item)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }